export default {
  state: {
    professional: {},
    occupation: {},
    professionalsFilters: {},
  },

  getters: {
    getProfessionalData: (state) => state.professional,
    getProfessionalOccupationData: (state) => state.occupation,
    getProfessionalsFilters: (state) => state.professionalsFilters,
  },

  mutations: {
    setProfessionalData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.professional = {
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        cpf: isUpdate ? data.cpf : "",
        cns: isUpdate ? data.cns : "",
        email: isUpdate ? data.email : "",
        mainPhone: isUpdate ? data.main_phone : "",
        secondaryPhone: isUpdate ? data.secondary_phone : "",
        unities: isUpdate ? data.unities.map((unity) => unity.id) : "",
        occupations: isUpdate ? data.professional_ocupations : [],
        isUpdate: isUpdate,
      };
    },

    setProfessionalOccupationData(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.occupation = {
        occupationId: isUpdate ? data.id : "",
        occupation: isUpdate ? data.co_ocupation : "",
        subOccupation: isUpdate
          ? data?.co_sub_ocupation
            ? parseInt(data.co_sub_ocupation)
            : data.co_sub_ocupation
          : "",
        council: isUpdate ? data.council : "",
        isUpdate: isUpdate,
      };
    },

    setgProfessionalsFilters(state, filters) {
      state.professionalsFilters = filters;
    },
  },

  actions: {
    changeProfessionalData(context, data) {
      context.commit("setProfessionalData", data);
    },

    changeProfessionalOccupationData(context, occupation) {
      context.commit("setProfessionalOccupationData", occupation);
    },

    changeProfessionalsFilters(context, filters) {
      context.commit("setgProfessionalsFilters", filters);
    },
  },
};
